import { Controller } from "@hotwired/stimulus"
import { Calendar } from '@fullcalendar/core';
import itLocale from '@fullcalendar/core/locales/it';
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';

// Connects to data-controller="fullcalendar_movements"
export default class extends Controller {
  connect() {
    if (this.element.id == 'calendar') {
      console.log('xxxxxxxxxxxxxxxx')
      const config = this.calendarConfig();
      config['events'] = this.getEventUrl();
      config['resources'] = this.getResourceUrl();
      config['initialDate'] = this.element.dataset.starttime;
      config.resourceAreaColumns[0].headerContent = 'Consegne';
      this.initFullCalendar(config)
      this.calendar.render()
    }
  }

  initFullCalendar(config) {
    this.calendar = new Calendar(document.getElementById('calendar'), config)
  }

  // filterChanged(selectedFilter, headerContent, view, license_id, date, typology, obj_id) {
  //   if (!this.calendar) {
  //     const config = this.calendarConfig();
  //     config['events'] = this.getEventUrl(selectedFilter, license_id, date, typology, obj_id);
  //     config['resources'] = this.getResourceUrl(selectedFilter, license_id, obj_id);
  //     config['initialView'] = view;
  //     config['initialDate'] = date;
  //     config.resourceAreaColumns[0].headerContent = headerContent;
  //     this.initFullCalendar(config);
  //     this.calendar.render()
  //   }
  // }

  getEventUrl() {
    return '/movements/get_events';
  }

  getResourceUrl() {
    return '/movements/get_resources';
  }

  calendarConfig() {
    return {
      schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
      locale: itLocale,
      plugins: [dayGridPlugin, timeGridPlugin, listPlugin, resourceTimelinePlugin, interactionPlugin],
      headerToolbar: {
        left: 'prevYear,prev,next,nextYear today',
        center: 'title',
        right: 'dayGridMonth'
        // right: 'timeGridWeek,timeGridDay' // user can switch between the two
      },
      // titleFormat: '{MMMM {D}}, YYYY',
      titleFormat: function (calendarDate) {
        var date = calendarDate
        var month = ""
        switch (calendarDate.start.month) {
          case 0:
            month = 'Gennaio'
            break;
          case 1:
            month = 'Febbraio'
            break;
          case 2:
            month = 'Marzo'
            break;
          case 3:
            month = 'Aprile'
            break;
          case 4:
            month = 'Maggio'
            break;
          case 5:
            month = 'Giugno'
            break;
          case 6:
            month = 'Luglio'
            break;
          case 7:
            month = 'Agosto'
            break;
          case 8:
            month = 'Settembre'
            break;
          case 9:
            month = 'Ottobre'
            break;
          case 10:
            month = 'Novembre'
            break;
          case 11:
            month = 'Dicembre'
            break;
          default:
            return '';
        }
        return `${month} ${calendarDate.start.year}`
      },
      navLinks: true, // can click day/week names to navigate views
      height: 'auto',
      resourceOrder: 'order',
      resourceAreaWidth: "20%",
      nowIndicator: true,
      displayEventTime: false,
      dayMaxEvents: true, // allow "more" link when too many events
      dragRevertDuration: 50,
      slotDuration: '24:00:00',
      slotLabelFormat: [
        { month: 'long', year: 'numeric' }, // top level of text
        { weekday: 'short' },
      ],
      eventOrder: 'payment_date, resource_name',
      eventOrderStrict: true,
      eventResizableFromStart: true,
      editable: true,
      eventDurationEditable: false,   // niente resize
      eventStartEditable: true, // permette drop
      dragScroll: true,
      resourceAreaColumns: [
        {
          headerContent: ''
        },
      ],

      eventContent: function (info) {
        return {
          html: info.event.title,
        };
      },

      eventClick: function (info) {

        window.location.href = "/movements?movement_id=" + info.event.id;

        // Prevent default behavior (optional)
        info.jsEvent.preventDefault();
      },

      dateClick: (arg) => {
        // Clicco in un giorno del calendario
        var element = arg.dayEl
        if (element && element.querySelector('.delete-holiday')) {
          return false;
        } else {
          arg.dayEl.style.backgroundColor = '#e1e8ee';
          let m = toMoment(arg.date, this.calendar); // calendar is required
          window.location.href = "/movements/new?start_time=" + m.format();
        }
      },

      eventDrop: function (arg) {
        console.log('drop')

        fetch(`/movements/${arg.event.id}/change_event`, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
          },
          body: JSON.stringify({
            event: 'drop',
            days: arg.delta.days
          })
        })
          .then(response => {
            if (!response.ok) {
              arg.revert()
            }
          })
          .catch(() => {
            arg.revert()
          })
      },

      eventResize: function (arg) {
        fetch(`/movements/${arg.event.id}/change_event`, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
          },
          body: JSON.stringify({
            event: 'resize',
            start: arg.startDelta?.days || 0,
            end: arg.endDelta?.days || 0
          })
        })
          .then(response => {
            if (!response.ok) {
              arg.revert()
            }
          })
          .catch(() => {
            arg.revert()
          })
      },

      viewDidMount: function (view) {
        // Cambio la visualizzazione da mensile a settimanale
      },

      // Cambio settimana/mese/anno
      datesSet: (info) => this.handleClick(new Date(info.start)),
    }
  }

  getCalendarMonth(month) {

  }


  handleClick() {
    const calendarEl = document.getElementById('calendar');
    if (!calendarEl) return;

    const buttons = [
      '.fc-prev-button',
      '.fc-next-button',
      '.fc-prevYear-button',
      '.fc-nextYear-button'
    ];

    buttons.forEach(selector => {
      const btn = calendarEl.querySelector(selector);
      if (btn) {
        btn.addEventListener('click', () => this.updateResourceData());
      }
    });
  }

  updateResourceData() {
    const calendarEl = document.getElementById('calendar');
    if (!calendarEl) return;

    const calendar = this.calendar; // FullCalendar instance
    if (!calendar) return;

    const startDate = calendar.view.currentStart; // start della vista attuale
    const year = startDate.getFullYear();
    const month = startDate.getMonth() + 1;
    const day = startDate.getDate();

    const start = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;

    const resourceEl = document.getElementById('resource');
    if (resourceEl) {
      resourceEl.dataset.initialdate = start;
    }

    console.log('updateResourceData', start);
  }
}
